module.exports = __webpack_public_path__ + "img/buy-icon2-en.26a52fb.png";